import styled from "styled-components";
import { Layout } from "antd";
import logo from "../../../assets/images/logo_Intelesafety.svg";
import logoSmall from "../../../assets/images/logo_Intelesafety_s.svg";

const { Sider } = Layout;

const Styles = styled(Sider)`
  & {
    background: #393e47;
    padding-top: 64px;
  }
  & .logo {
    height: 23px;
    background: url(${logo}) no-repeat left 60px top;
    text-align: center;
    margin: 0 auto 24px;
    text-indent: -999px;
    overflow: hidden;
    @media all and (min-width: 768px) and (max-width: 1024px) {
      background: url(${logoSmall}) no-repeat center;
    }
  }

  & .user-info-zone {
    visibility: visible;
    @media all and (min-width: 768px) and (max-width: 1024px) {
      visibility: hidden;
    }
  }

  & .ant-menu {
    transition: none;
  }
  & .ant-menu.ant-menu-dark,
  & .ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: #393e47;
    font-size: 15px;
  }
  & .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: #292c33;
  }

  & .ant-menu > .ant-menu-submenu {
    font-size: 12px;
  }

  & .ant-menu-sub.ant-menu-inline > .ant-menu-item,
  & .ant-menu-inline .ant-menu-submenu-title,
  & .ant-menu-inline > .ant-menu-item {
    height: 50px;
    line-height: 50px;
    margin-bottom: 0;
    transition: none;
  }
  & .ant-menu-item {
    padding-left: 24px !important;
    & .anticon {
      font-size: 20px;
    }
  }

  /* 메뉴 2뎁스 열고 펼치기 기능 제거 */
  & .ant-menu-submenu-title {
    pointer-events: none;
    & .ant-menu-submenu-arrow {
      display: none;
    }
  }

  /* new 아이콘 */
  & .ico-new {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  /* 아이콘 및 알람 */
  & .alarm {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background: #ef5d5d;
    height: 14px;
    line-height: 14px;
    padding: 0 10px;
    color: #fff;
    font-size: 12px;
    border-radius: 7px;
  }

  /* 반응형 처리 */
  @media all and (min-width: 768px) and (max-width: 1024px) {
    &.ant-layout-sider {
      flex: 0 0 68px !important;
      max-width: 68px !important;
      min-width: 68px !important;
      width: 68px !important;
      transition: none;
    }
    & .ant-menu-item {
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      & > .anticon + .ant-menu-title-content {
        position: absolute;
        padding-left: 68px;
        width: 68px;
        overflow: hidden;
      }
    }

    & .ant-menu-submenu > .ant-menu-submenu-title {
      padding: 0 !important;
      text-align: center;
      max-width: 3em;
      margin: 0 auto;
      text-overflow: clip;
      display: block;
      margin-top: 4px;
    }
    & .alarm {
      transform: translateY(calc(-90%));
    }
  }

  @media all and (max-width: 767px) {
    & {
      padding-top: 0;
    }
    & .logo {
      height: 55px;
      margin: 0 auto;
      background-position: center;
    }

    & .ant-menu.ant-menu-root {
      margin: 0 20px;
      width: auto;
      height: calc(100% - 55px);
      overflow: auto;
      border-top: 1px solid #444a57;
    }
    &.ant-layout-sider {
      width: 100% !important;
      flex: 1 !important;
      max-width: 100% !important;
      height: 100vh;
      position: fixed;
      top: 0;
      z-index: 110;
      left: 0;
      transition: 0.1s;

      &:not(.sider-open) {
        left: -100%;
        @media all and (max-width: 299px) {
          left: 2000%; /* 버그수정 */
        }
      }
    }
    & .ant-menu-item,
    & .ant-menu-submenu-title {
      border-bottom: 1px solid #444a57;
      margin-top: 0;
    }
    & .btn-menu-close {
      position: absolute;
      top: 12px;
      left: 15px;
      color: #fff;
      background: transparent;
      border: 0;
      transition: none;
      & .anticon {
        font-size: 20px;
      }
    }
  }
`;

export default Styles;
